export default __webpack_public_path__ + "static/media/refresh.57d4f76f.svg";